class OtherTrendingWidgetImageObserver {
  constructor(configOptions = {}, callback) {
    this.options = {
      root: configOptions.root || null,
      rootMargin: configOptions.rootMargin || "0px",
      threshold: configOptions.threshold || 0.1
    };
    this.callback = callback;
    this.observer = new IntersectionObserver(this.handleIntersect, this.options);
  }

  observe = (targetElem) => {
    this.observer.observe(targetElem);
  };

  destroy = () => {
    this.observer.disconnect();
  };

  handleIntersect = (entries) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio >= this.options.threshold) {
        const img = entry.target.querySelector("img");
        // data-src is read from the wrapperElm so that the intersection observer does not need to read from props and can be cached
        const src = img.getAttribute("data-src");

        if (src) {
          img.src = src;
          img.classList.remove("h-10", "w-10");
          img.classList.add("h-full", "w-full", "object-cover");
          this.observer.unobserve(entry.target);
        }
      }
    });
  };
}

export default OtherTrendingWidgetImageObserver;
